<template>
	<div class="xsjl">
        <main>
            <div class="list">
                <h2>行驶记录</h2>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="chepai"
                    label="车牌"
                    placeholder="点击选择"
                    @click="showPicker = true"
                />

                <van-popup v-model:show="showPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                    />
                </van-popup>

                <div class="div1">
                    <span >驾驶员</span>
                    <div class="div2">
                        <el-select 
                            clearable
                            v-model="name" 
                            multiple 
                            size="mini"
                            placeholder="请选择">
                            <el-option
                                v-for="item in columns2"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="address"
                    label="出发地点"
                    placeholder="点击选择"
                    @click="showPicker3 = true"
                />
                <van-field v-model="address3" label="出发地点"  v-if="address=='其他'"/>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns3"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="出发时间"
                    placeholder="点击选择"
                    @click="showPicker5 = true"
                />

                <van-popup v-model:show="showPicker5" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm5"
                        @cancel="showPicker5 = false"
                    />
                </van-popup>

                <van-field v-model="licheng1" label="出发里程"  />


                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="address2"
                    label="到达地点"
                    placeholder="点击选择"
                    @click="showPicker4= true"
                />

                <van-field v-model="address4" label="到达地点"  v-if="address2=='其他'"/>

                <van-popup v-model:show="showPicker4" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns4"
                        @confirm="onConfirm4"
                        @cancel="showPicker4 = false"
                    />
                </van-popup>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time2"
                    label="到达时间"
                    placeholder="点击选择"
                    @click="showPicker6 = true"
                />

                <van-popup v-model:show="showPicker6" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm6"
                        @cancel="showPicker6 = false"
                    />
                </van-popup>
                <van-field v-model="licheng2" label="结束里程"  />

                <van-field v-model="toushu" label="运猪头数"/>
                <van-field v-model="siwangtoushu" label="死亡头数"/>
                <van-field v-model="beizhu" label="备注"  />


                <h4>请上传出发里程及到达里程水印照片</h4>
                <van-uploader  v-model="fileList" multiple :max-count="2"  :before-read="beforeRead"/>
                <br><br>
                <br><br>
                <van-button type="danger" style="width:100%" @click="sub()">提交</van-button>

            </div>
        </main>
    </div>
</template>

<script>
    import { url } from '../router/api';

	export default{
		data(){
			return{
                chepai:'',
                name:'',
                address:'',
                address2:'',
                address3:'',
                address4:'',
                toushu:'',
                siwangtoushu:'',
                beizhu:'',

                columns:['浙G55988','浙G60595','浙G96517','浙G97582','浙G97873','浙H13768','浙H21595','浙HA2827','浙HA3160','浙JA0067','浙JA6576','浙KM1092','浙KM2799'],
                columns2:['杜乔亮','朱允昌','段绍波','郭士印','吴国君','张烈志','杜文奇','田枪','王军','郭士印','程日生','王太山'],
                columns3:['义乌平望猪场','义乌下水碓猪场','义乌正康猪场','仙居三亩田猪场','仙居瓦窑头猪场','仙居下各猪场','衢州张村猪场','衢州莲花猪场','衢州横路猪场','丽水里塘猪场','丽水仓坑猪场','兰溪瑞溪猪场','兰溪百凤林猪场','东阳猪场','天台猪场','建德同壮猪场','浦江猪场','乐清猪场','义乌农牧机械','其他'],
                columns4:['义乌平望猪场','义乌下水碓猪场','义乌正康猪场','仙居三亩田猪场','仙居瓦窑头猪场','仙居下各猪场','衢州张村猪场','衢州莲花猪场','衢州横路猪场','丽水里塘猪场','丽水仓坑猪场','兰溪瑞溪猪场','兰溪百凤林猪场','东阳猪场','天台猪场','建德同壮猪场','浦江猪场','乐清猪场','义乌农牧机械','其他'],
                time:'',
                time2:'',
                licheng1:'',
                licheng2:'',

                fileList: [],
                loading:'',

                maxDate: new Date(2030, 10, 1),
                currentDate: new Date(),

                showPicker:false,
                showPicker3:false,
                showPicker4:false,
                showPicker5:false,
                showPicker6:false,
            }
        },

		methods: {
            onConfirm(value) {
                this.chepai = value;
                this.showPicker = false;
            },
            onConfirm3(value) {
                this.address = value;
                this.showPicker3 = false;
            },
            onConfirm4(value) {
                this.address2 = value;
                this.showPicker4 = false;
            },
            onConfirm5(value) {
                this.time = this.formatDate(value)
                this.showPicker5 = false;
            },
            onConfirm6(value) {
                this.time2 = this.formatDate(value)
                this.showPicker6 = false;
            },

            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },

            beforeRead(file){
               return this.$compress(file)
            },

            sub() {
                if(this.chepai=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入车牌',
                    }).then(() => {
                        return;
                    });
                } else if(this.name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入驾驶员',
                    }).then(() => {
                        return;
                    });
                } else if(this.address=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入出发地点',
                    }).then(() => {
                        return;
                    });
                } else if(this.address=='其他'&&this.address3=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入出发地点',
                    }).then(() => {
                        return;
                    });
                } else if(this.address2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入到达地点',
                    }).then(() => {
                        return;
                    });
                } else if(this.address2=='其他'&&this.address4=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入到达地点',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入出发时间',
                    }).then(() => {
                        return;
                    });
                } else if(this.time2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入到达时间',
                    }).then(() => {
                        return;
                    });
                }  else if(this.lichng1=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入起始里程',
                    }).then(() => {
                        return;
                    });
                }  else if(this.lichng2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请输入结束里程',
                    }).then(() => {
                        return;
                    });
                }  else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否确定提交',
                    }).then(() => {
                        this.sure()
                    }).catch(() => {});
                }
            },

            sure() {
                 if(this.fileList.length!=2) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传两张照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                        this.axios.post(url+'xs/upload_xsjl',(formData),{
                            headers: {  'Content-Type': 'multipart/form-data;' }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.sure2(res.data.data)
                            }  else {
                                this.loading.close();
                            }
                        }).catch(err=> {
                            this.loading.close();
                            console.log(err);
                        });
                }
            },

            sure2(photo) {
                this.name2 = this.name.join(',');
                this.axios.get(url+'xs/xsAdd', {
                    params:{
                        chepai: this.chepai,
                        name: this.name2,
                        address: this.address,
                        address2: this.address2,
                        address3: this.address3,
                        address4: this.address4,
                        time: this.time,
                        time2: this.time2,
                        toushu: this.toushu,
                        siwangtoushu: this.siwangtoushu,
                        licheng1: this.licheng1,
                        licheng2: this.licheng2,
                        beizhu:this.beizhu,
                        url:photo.toString()
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.fileList = []
                            this.chepai = ''
                            this.name = ''
                            this.address = ''
                            this.address2 = ''          
                            this.address3 = ''
                            this.address4 = ''
                            this.time = ''
                            this.time2 = ''
                            this.toushu = ''
                            this.siwangtoushu = ''
                            this.licheng1 = ''
                            this.licheng2 = ''
                            this.beizhu = ''
                            this.url = ''
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .xsjl main {
        font-size: 14px;
        padding: 40px 16px 60% 16px;
        background-color: #FFDCA3;
    }
    .xsjl .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .xsjl h2 {
        text-align: center;
        margin-bottom: 20px;
    }
   
    .xsjl /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
    .xsjl h4 {
        text-indent: 16px;
    }
    .xsjl /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }
    .xsjl[data-v-c2ee7228] /deep/ .van-field__label {
        flex: none;
        box-sizing: border-box;
        width: 6.8em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        
        word-wrap: break-word;
    }
    .xsjl .div1 {
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 10px 16px;
        overflow: hidden;
        color: #323233;
        font-size: 14px;
        line-height: 24px;
        background-color: #fff;
        span {
            flex: none;
            box-sizing: border-box;
            width: 6.2em;
            margin-right: 30px;
            color: #646566;
            text-align: left;
            word-wrap: break-word;
        }
        .div2 {
            position: relative;
            color: #969799;
            text-align: right;
            vertical-align: middle;
            word-wrap: break-word;
            select {
                width: 100%;
            }
        }
    }
</style>
